import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@clerk/react';

/**
 * Wraps routes that should only be accessible when signed out (e.g. /signin, /signup).
 * Redirects already-authenticated users to /app so they never see a blank auth screen.
 * Returns null while Clerk is loading to prevent a redirect flash.
 */
export function PublicOnlyRoute() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) return null;
  if (isSignedIn) return <Navigate to="/app" replace />;

  return <Outlet />;
}
